module.exports = __webpack_public_path__ + "img/upload.cb6d5b78.svg";